/**
 * Smooth Accordion Controller for Impact FAQ - Guitar Tech
 */
(function () {
  'use strict';

  class ImpactSmoothAccordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.impact-faq-item__content');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      if (this.summary && this.content) {
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },
        { duration: 260, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      const parentCard = this.el.closest('.impact-faq-card');
      if (parentCard) {
        const siblings = parentCard.querySelectorAll('details.impact-faq-item');
        siblings.forEach((sib) => {
          if (sib !== this.el && sib.open && sib._accordionController) {
            sib._accordionController.shrink();
          }
        });
      }

      const startHeight = `${this.el.offsetHeight}px`;
      this.el.style.overflow = 'hidden';
      this.el.open = true;
      this.el.setAttribute('aria-expanded', 'true');

      const endHeight = `${this.summary.offsetHeight + this.content.scrollHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.isExpanding = true;
      this.isClosing = false;

      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(isOpen) {
      this.el.open = isOpen;
      this.el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = '';
      this.el.style.overflow = '';
    }
  }

  function initImpactAccordions(root) {
    const scope = root || document;
    scope.querySelectorAll('details.impact-faq-item').forEach((detail) => {
      if (!detail._accordionController) {
        detail._accordionController = new ImpactSmoothAccordion(detail);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initImpactAccordions());
  } else {
    initImpactAccordions();
  }

  document.addEventListener('shopify:section:load', (e) => initImpactAccordions(e.target));
})();
